import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.sass'
})
export class RedirectComponent {
  constructor(private router: Router) {
    this.router.navigate(['/dashboard/pps']); // Hier wird die Weiterleitung durchgeführt
  }
}
